<!--协同备课、听评课总数统计饼图-->
<template>
    <div class="my-charts">
        <div :id="id"></div>
    </div>
</template>


<script>
import * as echarts from "echarts";

export default {
    name: "teaZcEchart",
    props: {
        id:{
            type: String,
            default:"tea_zc_pie_echarts"
        },
        teaZcCount1:{
            type: Number,
            default: 0
        },
        teaZcCount2:{
            type: Number,
            default: 0
        },
        teaZcCount3:{
            type: Number,
            default: 0
        },
    },
    watch:{
        id(newValue,oldValue){
            this.id = newValue;
        },
    },
    data() {
        return {
            pieChart: null, // 饼图
            chartOption:{
                title: {
                    text: '',
                    left: 'center',
                    top: 10,
                },
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    show: false,
                    bottom:0,
                },
                graphic: [
                    {
                        type: "text",
                        left: "center",
                        top: "center",
                        style: {
                            text: '',
                            textAlign: "center",
                            fill: "#333333",
                            lineHeight:30,
                            fontSize: 14
                        },
                    },
                ],
                series: [
                    {
                        name: '',
                        type: 'pie',
                        radius: ['50%', '75%'],
                        avoidLabelOverlap: false,
                        color: [
                            '#5087ec',
                            '#68bbc4',
                            '#ee6616',
                        ],
                        itemStyle: {
                            borderRadius: 0,
                            borderColor: '#fff',
                            borderWidth: 1
                        },
                        label: {
                            show: false,
                            position: 'center'
                        },
                        emphasis: {
                            label: {
                                show: false,
                                fontSize: 10,
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: true
                        },
                        data: []
                    }
                ]
            }
        };
    },
    computed: {},
    mounted() {
        this.init();
    },
    updated() {
        this.init();
    },
    methods: {
        init() {
            const list = []
            list.push({'value':this.teaZcCount1,'name':"高级及以上"});
            list.push({'value':this.teaZcCount2,'name':"一级教师"});
            list.push({'value':this.teaZcCount3,'name':"二级及其他"});
            this.pieChart = echarts.init(document.getElementById(this.id));
            this.chartOption.series[0].data = []
            this.chartOption.series[0].data = list;
            this.chartOption.graphic[0].style.text = "职称";
            this.pieChart.setOption(this.chartOption);
        }
    }
};
</script>

<style scoped lang="scss">
.my-charts {
    flex-direction: column;
    div {
        width: 100%!important;
        height: 100px;
    }
}
</style>